import React from "react";

const Svg = ({width = 31}: {width?: number} = {}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1807_1718)">
        <mask
          id="mask0_1807_1718"
          style={{maskType: "luminance"}}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="31"
          height="31">
          <path d="M31 0H0V31H31V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1807_1718)">
          <path
            d="M22.928 24.341L22.8246 24.4219C20.0887 26.6435 16.6051 27.7313 13.0912 27.4612C9.57729 27.1912 6.30076 25.5838 3.93647 22.9703C1.57218 20.3568 0.300185 16.9361 0.382481 13.4128C0.464777 9.88946 1.8951 6.53188 4.37883 4.03159C6.86256 1.5313 10.2106 0.0787013 13.7332 -0.027003C17.2559 -0.132707 20.685 1.11653 23.3142 3.4634C25.9434 5.81027 27.5724 9.07605 27.8658 12.5881C28.1592 16.1001 27.0946 19.5909 24.8913 22.3415L24.8104 22.4431L24.8224 22.6343L31.3875 29.2011L29.5861 31.0043L22.928 24.341ZM14.1395 2.548C12.3036 2.54811 10.4958 2.99919 8.87509 3.8616C7.25436 4.724 5.87029 5.97133 4.84454 7.49393C3.81878 9.01654 3.18275 10.7678 2.99234 12.5938C2.80194 14.4198 3.063 16.2646 3.75256 17.9661C4.44213 19.6675 5.53909 21.1736 6.94704 22.3518C8.35498 23.53 10.0308 24.3443 11.8272 24.7232C13.6235 25.1021 15.4855 25.0338 17.2493 24.5246C19.0132 24.0153 20.6249 23.0805 21.9429 21.8024L22.1805 21.5682C23.716 19.9876 24.7516 17.9894 25.1579 15.8236C25.5643 13.6577 25.3233 11.4201 24.4652 9.39033C23.6071 7.3606 22.1698 5.62877 20.333 4.41122C18.4963 3.19367 16.3414 2.54441 14.1377 2.54456"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1807_1718">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Svg;
